<template>
  <div class="block-r">
    <div class="block-r__letter letter letter-white" data-aos="fade-up">
      Р.
    </div>
    <div class="block-r__row">
      <div class="block-r__image" data-aos="fade-up">
        <img src="../assets/img/block-r-1-m.png" alt="">
      </div>
    </div>
    <div class="block-r__title" data-aos="fade-up"><i><span>20</span>-ые</i> <p>Ревущие</p></div>
    <div class="block-r__text text-white" data-aos="fade-up">Конец Первой мировой войны ознаменовал начало новой эпохи — эпохи расцвета джаза, арт-деко, повсеместного радиовещания и появления звука в кинематографе. Благодаря беспрецедентному росту промышленности и потребительского спроса, научным открытиям и технологическому прогрессу дух ревущих двадцатых воспринимался современниками, как время разрыва <br>с традиционными ценностями, время фривольного дикого танца, время, когда осуществимо всё.</div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-r__letter
      margin-left: vwm(175px) !important
      margin-top: vwm(79px) !important
      padding-left: vwm(18px) !important
      position: relative
      z-index: 100
    .block-r__title
      font-size: vwm(61.78px) !important
      text-align: right
      font-style: normal
      i
        margin-top: vwm(-88px) !important
        margin-left: vwm(118px)
        font-style: normal !important
        display: block !important
        span
          font-size: vwm(134.845px)
      p
        margin-left: vwm(-78px)
        margin-top: vwm(-13px)
    .block-r__row
      padding-left: 0 !important
    .block-r__image
      width: 100vw !important
      margin-left: 0 !important
      margin-top: vwm(-119px) !important
    .block-r__text
      margin-left: vwm(16px) !important
      font-size: vwm(17px) !important
      width: 90vw !important
      text-align: left !important
      line-height: vwm(22.3px) !important
      margin-top: vwm(54px) !important
      br
        display: none
      p
        margin-bottom: vwm(25px)
</style>
